import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import PBI_SRC from '../../common/constants/PowerbiSourceUrl';
import { setDrawerOpened } from '../HomePage/ContentTabs/ContentTabsSlice';
import useStyles from './styles';

export default function MonitoringPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleClickAway = () => {
    dispatch(setDrawerOpened(false));
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Typography className={classes.title}>
          {t('Wagon availabilty forecast monitoring')}
        </Typography>
        <Paper elevation={0} className={classes.contentPaper}>
          <div className={classes.description}>
            You will be able to monitor forecast error by business unit and
            product type. The error is calculated on one-month real and forecast
            data. You can access to statistics of each point to compare the
            difference between those curves.
          </div>
          <div
            className={classes.iframe}
            data-testid="wagon-availability-monitoring"
          >
            <iframe
              onLoad={handleClickAway}
              title="Wagon availability forecast monitoring"
              width="100%"
              height="550px"
              src={PBI_SRC.monitoring}
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </Paper>
      </Grid>
    </div>
  );
}
